<template>
  <div class="trial-timeline-screen">
    <ScreenHeading> First week is on us </ScreenHeading>
    <div aria-hidden="true" class="line"></div>
    <div class="steps-container">
      <div class="step-container">
        <div class="marker-and-heading">
          <div class="marker highlight">
            <Lock />
          </div>
          <h3 class="heading highlight">Today</h3>
        </div>
        <p class="text">Full access to {{ productName }}. Cancel anytime.</p>
      </div>
      <div class="step-container">
        <div class="marker-and-heading">
          <div class="marker">
            <Bell />
          </div>
          <h3 class="heading">Day 4</h3>
        </div>
        <p class="text">We'll remind you by email that your trial is about to end.</p>
      </div>
      <div class="step-container">
        <div class="marker-and-heading">
          <div class="marker">
            <Star />
          </div>
          <h3 class="heading">Day 7</h3>
        </div>
        <p class="text">You'll be charged, cancel anytime before.</p>
      </div>
    </div>
    <ScreenNextSectionBtn @navigateClick="handleSaveAndContinue" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import Lock from '@/components/shared/svg/Lock.vue'
import Bell from '@/components/shared/svg/Bell.vue'
import Star from '@/components/shared/svg/Star.vue'
import ScreenHeading from '@/components/shared/screens/ScreenHeading.vue'
import ScreenNextSectionBtn from '@/components/shared/screens/ScreenNextSectionBtn.vue'
import { useScreenStore } from '@/store/ScreenStore'
import { usePlanStore } from '@/store/PlanStore'
import { useProductStore } from '@/store/ProductStore'
import { useAmplitude } from '@outputinc/o-analytics'

const { track, Events } = useAmplitude()
const { setScreenComplete } = useScreenStore()
const planStore = usePlanStore()
const { selectedPlanProduct, selectedPlanCode } = storeToRefs(planStore)
const productStore = useProductStore()
const { productName } = storeToRefs(productStore)
const emit = defineEmits(['navigateNext'])

const handleSaveAndContinue = () => {
  setScreenComplete(true)
  emit('navigateNext')
}

onMounted(() =>
  track(Events.CHECKOUT_SUBSCRIPTION_TRIAL_TIMELINE_VIEWED, {
    products: [selectedPlanProduct.value],
    planCode: selectedPlanCode.value
  })
)
</script>

<style lang="scss" scoped>
.trial-timeline-screen {
  position: relative;
  max-width: $grid-breakpoint-sm;
  padding: 0 $spacer-3;
  margin: $spacer-5 auto;

  @media (min-height: 769px) {
    margin: $spacer-9 0 $spacer-5;
  }

  @include media-breakpoint(sm) {
    padding: 0 $spacer-7;
  }
}

.line {
  width: 1px;
  position: absolute;
  z-index: -1;
  background: var(--color-icon-background);
  top: 120px;
  left: 35px;
  height: 240px;

  @include media-breakpoint(sm) {
    top: 90px;
    left: 83px;
    height: 280px;
  }
}

.steps-container {
  margin-bottom: 90px;

  @include media-breakpoint(md) {
    margin-bottom: 110px;
  }

  .step-container {
    display: flex;
    flex-direction: column;
    margin-bottom: $spacer-4;

    .marker-and-heading {
      display: flex;
      align-items: center;

      .marker {
        background: var(--color-icon-background);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        margin-right: $spacer-3;
        display: flex;
        justify-content: center;
        align-items: center;

        &.highlight {
          background: var(--color-accent-primary);
        }
      }

      .heading {
        font-family: $font-family-pilat-bold;
        padding-top: 8px;
        margin-bottom: 8px;
        font-size: 20px;

        &.highlight {
          color: var(--color-text-highlight) !important;
        }
      }
    }

    .text {
      color: var(--color-text-secondary);
      line-height: 24px;
      margin-bottom: 0;
      margin-left: 57px;
      max-width: 328px;
    }
  }
}
</style>
